import { useState, MouseEvent } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  IconButton, ListItemIcon, Menu, MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { MenuMoreVertPosition } from '../../consts/enums';
import style from './style';

const positions = {
  [MenuMoreVertPosition.top]: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  },
  [MenuMoreVertPosition.button]: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  },
} as const;

type Props = {
  actions: {
    key: string,
    type: string,
    title: string,
    icon: JSX.Element,
    isDisabled?: boolean,
  }[],
  position?: MenuMoreVertPosition,
  handleActions: (id: string, type: string,) => void,
}

const MenuMoreVert = ({
  actions, handleActions, position,
}: Props): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const actionActions = (event: MouseEvent<HTMLElement>, key: string, type: string) => {
    handleClose(event);
    handleActions(key, type);
  };

  const renderItems = () => actions.map((action) => (
    <MenuItem
      key={ uuidv4() }
      disabled={ action.isDisabled || false }
      onClick={
        (e) => actionActions(e, action.key, action.type)
      }
    >
      <ListItemIcon>
        { action.icon }
      </ListItemIcon>
      {action.title}
    </MenuItem>
  ));

  return (
    <>
      <IconButton
        aria-label={ style.aria.label }
        id={ style.aria.controls }
        aria-controls={ style.aria.id }
        aria-expanded={ open ? 'true' : undefined }
        aria-haspopup="true"
        onClick={ handleClick }
        color="primary"
        sx={  { borderRadius: '48px' } }
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        onClick={ (event) => event.stopPropagation() }
        anchorOrigin={ positions[position || MenuMoreVertPosition.top].anchorOrigin }
        transformOrigin={ positions[position || MenuMoreVertPosition.top].transformOrigin }
        id={ style.aria.id }
        MenuListProps={ {
          'aria-labelledby': style.aria.controls,
        } }
        anchorEl={ anchorEl }
        open={ open }
        onClose={ handleClose }
      >
        { renderItems() }
      </Menu>
    </>
  );
};

MenuMoreVert.defaultProps = {
  position: MenuMoreVertPosition.top,
};

export default MenuMoreVert;
